import React from 'react'
import Layout from '../components/Layout'

const NotFoundPage = () => (
  <Layout
    langKey="es"
    slug="/"
  >
    <section className="hero is-fullheight">
      <div className="hero-body">
        <div className="container has-text-centered is-size-8">
          <h1
            className="has-text-vivid-red has-text-weight-bold"
            style={{padding: '1rem'}}
          >
            Esta página no parece existir.
          </h1>
          <h2 className="has-text-weight-bold">
            Parece que el enlace que señala aquí fue defectuoso.
          </h2>
        </div>
      </div>
    </section>
  </Layout>
)

export default NotFoundPage
